export const sections = {
  OVERVIEW: 'overview',
  ONLINE_REVIEW: 'online_review',
  FEEDBACK: 'feedback',
  AI_INSIGHTS: 'ai_insights',
  ALERTS: 'alerts'
};
